import { LocationList as LocationListPage } from './location-list/location-list'
import AddLocationPage from './add-location/add-location'
import EditLocationPage from './edit-location/edit-location'

export const LocationsStack = {
  AddLocationPage,
  EditLocationPage,
  LocationListPage,
}
